import { Stack, Typography } from '@mui/material';

interface Props {
  label: string;
  value: string;
}

const DataCell = ({ label, value }: Props) => {
  return (
    <Stack direction={'row'} justifyContent={'space-between'}>
      <Typography variant="body2" color="textSecondary">
        {label}
      </Typography>
      <Typography variant="body2">{value}</Typography>
    </Stack>
  );
};

export default DataCell;
